import { Observable, of } from 'rxjs';
import { FormActionType } from '@app/finxone-web-frontend/app/lib/state/form-submision.state';
import { Store } from '@ngxs/store';
import { SetFormAction } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import { ExchangeTransactionResponse } from '@finxone-platform/shared/sys-config-types';

export class MockExchangeService {
  constructor(private store: Store) {
    // mock the form Action with Quote data
    const formActionData = {
      type: '',
      nextPageUrl: '',
      formData: {
        amount: '10',
        buyAccountId: '50aa2cd0-75a4-4e92-9445-1a3657df6a8b',
        sellAccountId: '41beb46f-5c0c-48b5-b5b5-c1170e8fc514',
      },
      isLastPage: false,
    } as FormActionType;
    this.store.dispatch(new SetFormAction(formActionData));
  }

  public postExchangeQuote(requestData: any): Observable<any> {
    return of({
      quoteId: '7270e6c8-f539-44ca-82d5-8f2c10be19b2',
      exchangeRate: 1.234644755,
      buyCurrency: 'EUR',
      buyAmount: 3.7,
      sellCurrency: 'GBP',
      sellAmount: 3,
      feeAmount: 0,
      feeCurrency: '',
      exchangeDate: '2024-01-22',
      expiryDateTime: '2024-01-22 07:58:36 am',
      cutOffTimeInMinutes: -21,
      settlementDate: '2024-01-22',
      debitAmount: 3,
      creditAmount: 3.7,
    });
  }

  // POST /exchanges/transactions returns the booked exchange; the quote data
  // above is the one this mock hands out, so the accepted trade echoes it.
  public postAcceptQuote(quoteId: string): Observable<ExchangeTransactionResponse> {
    return of({
      id: 'a2f9c8d5-7b34-4f21-9c17-6d4f2b8e0a13',
      quoteId,
      transactionNumber: '20240122-EQ7RTK',
      exchangeRate: 1.234644755,
      serviceProviderBuyAmount: 3.7,
      serviceProviderSellAmount: 3,
      serviceProviderRate: 1.234644755,
      buyCurrency: 'EUR',
      buyAmount: 3.7,
      buyAccountId: '50aa2cd0-75a4-4e92-9445-1a3657df6a8b',
      sellCurrency: 'GBP',
      sellAmount: 3,
      sellAccountId: '41beb46f-5c0c-48b5-b5b5-c1170e8fc514',
      feeAmount: 0,
      feeCurrency: 'GBP',
      debitAmount: 3,
      creditAmount: 3.7,
      cancellationFee: null,
      originalExchangeDate: '2024-01-22',
      exchangeDate: '2024-01-22',
      settlementDate: '2024-01-22',
      fixedSide: 'buy',
      sender: {
        accountNumber: '12345678',
        name: 'Anne Miller',
        sortCode: '000000',
      },
      receiver: {
        accountNumber: '12345678',
        sortCode: '000000',
        name: 'Anne Miller',
      },
      status: 'completed',
    });
  }

  public getExchangeDetail(exchangeId: string): Observable<ExchangeTransactionResponse> {
    const responseData: ExchangeTransactionResponse = {
      id: 'eb11d186-1171-4487-9e7b-01ebc989c039',
      quoteId: 'e4e952a0-0071-4ed7-9f4b-acae5f3999bf',
      transactionNumber: '20240320-EQ5WQJ',
      exchangeRate: 0.710076,
      serviceProviderBuyAmount: 10,
      serviceProviderSellAmount: 14.08,
      serviceProviderRate: 0.710076,
      buyCurrency: 'GBP',
      buyAmount: 10,
      buyAccountId: '41beb46f-5c0c-48b5-b5b5-c1170e8fc514',
      sellCurrency: 'USD',
      sellAmount: 14.08,
      sellAccountId: '9301a25d-4ca6-4a07-a6c8-8ce9e1082a1b',
      feeAmount: 0,
      feeCurrency: 'USD',
      debitAmount: 14.08,
      creditAmount: 10,
      cancellationFee: null,
      originalExchangeDate: '2024-03-20',
      exchangeDate: '2024-03-20',
      settlementDate: '2024-03-20',
      fixedSide: 'buy',
      sender: {
        accountNumber: '12345678',
        name: 'Anne Miller',
        sortCode: '000000',
      },
      receiver: {
        accountNumber: '12345678',
        sortCode: '000000',
        name: 'Brandon Taylor',
      },
      status: '',
    };
    return of(responseData);
  }
}
